export interface Store {
    id: number;
    name: string;
    logoUrl: string;
    metaKeywords: string[];
    code: string;
    description: string;
    favorite_color?:string;
}
